import { defineComponent } from 'vue'
import { HAPTICS_FEEDBACK, createNamespace } from '@xzx-design/utils'
import { bem, t } from './utils'

const [name] = createNamespace('select-toolbar')

export const selectToolbarProps = {
  title: String,
  cancelButtonText: String,
  confirmButtonText: String,
}

export const selectToolbarSlots = ['cancel', 'confirm', 'title', 'toolbar']

export type SelectToolbarPropKeys = Array<keyof typeof selectToolbarProps>

export const selectToolbarPropKeys = Object.keys(
  selectToolbarProps
) as SelectToolbarPropKeys

export default defineComponent({
  name,

  props: selectToolbarProps,

  emits: ['confirm', 'cancel'],

  setup(props, { emit, slots }) {
    const renderTitle = () => {
      if (slots.title) {
        return slots.title()
      }
      if (props.title) {
        return <div class={[bem('title'), 'xzx-ellipsis']}>{props.title}</div>
      }
    }

    const onCancel = () => emit('cancel')
    const onConfirm = () => emit('confirm')

    const renderCancel = () => {
      const text = props.cancelButtonText ?? t('cancel')

      if (!slots.cancel && !text) {
        return
      }

      return (
        <button
          type="button"
          class={[bem('cancel'), HAPTICS_FEEDBACK]}
          onClick={onCancel}
        >
          {slots.cancel ? slots.cancel() : text}
        </button>
      )
    }

    const renderConfirm = () => {
      const text = props.confirmButtonText ?? t('confirm')

      if (!slots.confirm && !text) {
        return
      }

      return (
        <button
          type="button"
          class={[bem('confirm'), HAPTICS_FEEDBACK]}
          onClick={onConfirm}
        >
          {slots.confirm ? slots.confirm() : text}
        </button>
      )
    }

    return () => (
      <div class={bem('toolbar')}>
        {slots.toolbar
          ? slots.toolbar()
          : [renderCancel(), renderTitle(), renderConfirm()]}
      </div>
    )
  },
})
